"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var useContextConfig_1 = __importDefault(require("../useSkeletonConfig/useContextConfig"));
var Skeleton = function (_a) {
    var width = _a.width, height = _a.height, type = _a.type, className = _a.className, margin = _a.margin, padding = _a.padding, borderRadius = _a.borderRadius, style = _a.style;
    var _b = (0, useContextConfig_1.default)(), animation = _b.animation, animationSpeed = _b.animationSpeed, backgroundColor = _b.backgroundColor, highLightColor = _b.highLightColor, secondaryColor = _b.secondaryColor, innerStyles = _b.innerStyles;
    var inlineStyles = __assign({ width: width, height: height, margin: margin, padding: padding, borderRadius: borderRadius, backgroundColor: backgroundColor }, style);
    var customInnerStyles = {
        background: "linear-gradient(to right, ".concat(secondaryColor, ", ").concat(highLightColor, ", ").concat(secondaryColor, ")"),
        animation: animation ? "loading ".concat(animationSpeed, "s infinite") : '',
    };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('shape', "shape-".concat(type), 'animation', className), style: inlineStyles, "data-testid": "skeleton-shape" },
        react_1.default.createElement("div", { className: "animation__inner-panel", style: __assign(__assign({}, innerStyles), customInnerStyles) })));
};
exports.default = Skeleton;
